export interface IPageContent {
  pageId: string;
  pageTitle: string;
  content: ICommonPageContent[];
}

export interface IPageContentShort {
  pageId: string;
  pageTitle: string;
}

export interface ICommonPageContent {
  id: string;
  title?: string;
  text?: string;
  src?: string;
  href?: string;
  name?: string;
  price?: string;
  status?: string;
  description?: string;
}

export const PLACEHOLDERS: any = {
  text: "укажите текст",
  src: "имя изображения",
  href: "укажите ссылку",
  price: "укажите цену",
  name: "укажите название",
  status: "укажите статус",
  description: "укажите описание",
  shortDescription: "укажите краткое описание"
};

//any у него стоит потому что тайпскрипт не дает сделать obj[key]
